import Vue from 'vue';
import SharedMixin from '../Mixins/Shared';
export default {
  inject: ['load'],
  mixins: [SharedMixin],
  data() {
    return {
      user: null,
      userFullName: '',
      userRoleTitle: '',
    };
  },
  methods: {
    getUserFunctionForMainPage: function () {
      this.$store.dispatch('csrf').then(() => {
        if (this.$store.state.loginModule.successFlag) {
          this.$store.dispatch('getUserCurrent').then(() => {
            if (this.$store.state.userModule.successFlag) {
              this.user = this.$store.state.userModule.user;
              this.userFullName = this.user.firstName + ' ' + this.user.lastName;
              this.userRoleTitle = '';
              this.userRoles = [];
              let flag = false;
              for (let i = 0; i < this.user.roles.length; i++) {
                this.userRoles.push(this.user.roles[i]);
                if (this.user.roles[i].id == 3) {
                  flag = true;
                }
              }
              if (this.user.currentExtension) {
                this.userExtension = this.user.currentExtension.sipExtension;
              }
              if (flag) {
                this.checkDND(this.user);
              }
              this.defineMenuItems(this.user);

            } else {
              if (this.$store.state.userModule.errorStatus) {
                this.$store.dispatch('refreshToken').then(() => {
                  if (this.$store.state.loginModule.successFlag) {
                    this.getUserFunctionForMainPage();
                  } else {
                    this.$router.push({ name: 'login' });
                  }
                });
              } else {
                this.snackText = this.$store.state.userModule.error;
                this.$refs.snackRef.snackModel = true;
                this.snackColor = '#FF5252';
                this.snakIcon = 'mdi-information';
              }
            }
          });
          this.getSystemSettingByClientComputer();
        } else {
          this.$router.push({ name: 'login' });
        }
      });
    },
    logOut: function () {
      this.$store.dispatch('logOut').then(() => {
        if (this.$store.state.userModule.successFlag) {
          this.$router.push({ name: 'login' });
          localStorage.clear();
          Vue.prototype.$mainSignalr.stop();
          Vue.prototype.$mobileSignalr.stop();
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(async () => {
              if (this.$store.state.loginModule.successFlag) {
                await this.logOut();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.snackText = this.$store.state.userModule.error;
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#FF5252';
            this.snakIcon = 'mdi-information';
          }
        }
      });
    },
    setPass: function () {
      if (this.newPassR != this.newPass) {
        this.snackText = 'رمز عبور با تکرار آن برابر نیست';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      this.$store
        .dispatch('changeUserPasssword', {
          oldPassword: this.oldPass,
          newPassword: this.newPass,
        })
        .then(() => {
          if (this.$store.state.userModule.successFlag) {
            this.snackText = 'رمز عبور شما با موفقیت تغییر یافت. لطفا مجددا به برنامه وارد شوید.';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#4CAF50';
            this.snakIcon = 'mdi-check-circle';
            this.changePassModal = false;
            this.oldPass = '';
            this.newPassR = '';
            this.newPass = '';
            setTimeout(() => {
              this.$router.push({ name: 'login' });
            }, 3000);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.userModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.setPass();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.snackText = this.$store.state.userModule.error;
              this.$refs.snackRef.snackModel = true;
              this.snackColor = '#FF5252';
              this.snakIcon = 'mdi-information';
            }
          }
        });
    },
  },
};
